import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";

import NotFound from "../NotFound/notFound";
import PropTypes from "prop-types";
import useHttp from "../../../hooks/useHttp";
import APIService from "../../../services/apiAxiosService";

function PwCIdentityRedirectEndpoint(props) {
  const history = useHistory();
  const [isInvalidAccess, setIsInvalidAccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const { sendRequest: idamAPI } = useHttp();

  const sendTheCodeToAPI = async (code) => {
    const body = {
      code,
    };
    setLoading(true);
    await idamAPI(
      APIService.idamSuccess(body),
      (res) => {
        setLoading(false);
        if (res.CODE) {
          history.push(res.path);
        } else {
          throw new Error("Error on validating PwC login");
        }
      },
      (err) => {
        console.log("Error", err);
        return setIsInvalidAccess(true);
      }
    );
  };

  const checkIfCodeIsAvailable = () => {
    try {
      const searchSplit = props.location.search.split("&");
      const codeReceived = searchSplit[0];
      const code = codeReceived.split("=")[1];
      if (code) {
        sendTheCodeToAPI(code);
      }
    } catch (err) {
      console.log("Error", err);
      return setIsInvalidAccess(true);
    }
  };
  useEffect(() => {
    // get unique code from url
    checkIfCodeIsAvailable();
  }, []);

  const displayInvalidAccess = () => {
    if (isInvalidAccess) {
      return <NotFound />;
    }
    return <></>;
  };

  return (
    <>
      {displayInvalidAccess()}
      {loading && (
        <>
          <span className="a-loading a-primary a-m-10 a-loading-16"></span> Login verification in progress. Please wait...
        </>
      )}
    </>
  );
}
PwCIdentityRedirectEndpoint.propTypes = {
  location: PropTypes.any
}
export default PwCIdentityRedirectEndpoint;
